import { WysiwygEditor } from 'components/wysiwyg/component'
import { ImageUpload } from 'components/image-upload/component'
import * as React from 'react'
import { Input, Label } from 'reactstrap'
import { getConfiguration } from '../../utils'
import { RasaContext } from 'context'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { IMAGE } from 'shared_server_client/constants'

interface HeaderSettingsProps {
  data: any
  name?: string
  onChange: (field: string, value: any) => void
}

interface HeaderSettingsState {
  error: boolean
  loadingImage: boolean
}

export class HeaderSettings extends React.Component<HeaderSettingsProps, HeaderSettingsState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore
  private communityId: string = null

  constructor(props: HeaderSettingsProps) {
    super(props)
    this.state = {
      error: false,
      loadingImage: false,
    }
    this.uploadImage = this.uploadImage.bind(this)
  }

  public componentDidMount() {
    this.sharedStore = SharedStore.instance(this.context)
    this.sharedStore.getValue(SharedKeys.activeCommunity)
    .then((activeCommunity) => {
      this.communityId = activeCommunity.communityId
    })
  }
  public render() {
    return (
      <div>
        <div className="widget-settings-section">
          <h4>Header Settings</h4>
          
          <div className="setting-item">
            <Label>Show Header</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_header_show', 'true')}
              onChange={(e) => this.props.onChange('survey_results_header_show', e.target.value)}
            >
              <option value="true">Show</option>
              <option value="false">Hide</option>
            </Input>
          </div>

          <div className="setting-item">
            <Label>Page Title</Label>
            <Input
              type="text"
              value={getConfiguration(this.props.data, 'survey_results_page_title', 'Survey Results')}
              onChange={(e) => this.props.onChange('survey_results_page_title', e.target.value)}
              placeholder="Survey Results"
            />
          </div>

          <div className="setting-item">
            <Label>Header Description</Label>
            <WysiwygEditor
              htmlEdited={false}
              html={getConfiguration(this.props.data, 'survey_results_header_description', 
                'See how others responded to this survey. Results are updated in real-time.')}
              onChange={(html: string, isHtmlEdited: boolean) => {
                this.props.onChange('survey_results_header_description', html)
              }}
            />
          </div>
        </div>

        <div className="widget-settings-section">
          <h4>Logo & Branding</h4>
          
          <div className="setting-item">
            <Label>Header Image URL</Label>
            <ImageUpload 
              imageUrl={getConfiguration(this.props.data, 'survey_results_header_image_url', '')}
              showCloseButton={true} 
              closeButtonClick={() => this.props.onChange('survey_results_header_image_url', '')}
              uploadImage={this.uploadImage} 
            />
          </div>
        </div>
      </div>
    )
  }

  private uploadImage(image: any) {
    const formData = new FormData()
    formData.append(IMAGE, image)
    const url: string = `${AjaxWrapper.getServerUrl()}/${this.communityId}/image`
    return AjaxWrapper.ajax(url, HttpMethod.POST, formData, null)
      .then((hostedImage) => {
        this.setState({
          loadingImage: false,
        })
        this.props.onChange('survey_results_header_image_url', hostedImage.url)
      })
      .catch((error) => {
        this.setState({
          error: true,
          loadingImage: false,
        })
      })
  }
}